
import React from 'react';
import { CountryItem } from '../types';
import { MobileCountryCard } from './MobileCountryCard';

interface MobileCountryListProps {
  countries: CountryItem[];
  editing: string | null;
  editData: CountryItem | null;
  onEditDataChange: (data: CountryItem) => void;
  onToggleActive: (id: string) => void;
  onSave: () => void;
  onDelete: (id: string) => void;
  onOpenDialog: (country: CountryItem) => void;
}

export const MobileCountryList: React.FC<MobileCountryListProps> = ({
  countries,
  editing,
  editData,
  onEditDataChange,
  onToggleActive,
  onSave,
  onDelete,
  onOpenDialog,
}) => {
  return (
    <div className="space-y-4">
      {countries.map((country) => (
        <MobileCountryCard
          key={country.code}
          country={country}
          editing={editing === country.id}
          editData={editing === country.id ? editData : null}
          onEditDataChange={onEditDataChange}
          onToggleActive={onToggleActive}
          onSave={onSave}
          onDelete={onDelete}
          onOpenDialog={onOpenDialog}
        />
      ))}
    </div>
  );
};
